<template lang="pug">
    v-dialog(v-model="dialog" max-width="480" scrollable persistent :fullscreen="$vuetify.breakpoint.smAndDown")
        v-card(tile v-if="item")
            v-card-title {{item.name}}
            v-card-text
                .text-center.subtitle-1 {{link}}
            v-card-actions
                v-btn(@click="copyToClipboard(link)" color="grey" depressed v-if="link").px-3.white--text
                    v-icon(left dark) mdi-content-copy
                    | {{$t('general.copyLink')}}
                v-btn(@click="openLink(link)" color="grey" depressed v-if="link").px-3.white--text
                    v-icon(left dark) mdi-web
                    | {{$t('general.openLink')}}
                v-spacer
                v-btn(@click="close" color="primary" depressed).px-3.white--text
                    v-icon(left dark) mdi-check
                    | {{$t('general.ok')}}
</template>

<script>
import { copyToClipboard, getFileViewerUrlFrom } from "../../utils";

export default {
  name: "GetLinkDialog",
  data() {
    return {
      dialog: false,
      item: null
    };
  },
  computed: {
    link() {
      return this.item ? getFileViewerUrlFrom(this.item) : "";
    }
  },
  methods: {
    show(item) {
      this.item = { ...item };
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.item = null;
      });
    },
    copyToClipboard(text) {
      copyToClipboard(text, this);
    },
    openLink(link) {
      this.close();
      this.$nextTick(() => {
        window.open(link, "_blank");
      });
    }
  }
};
</script>

<style scoped></style>
